<template>
  <organizations-table :view="view" :row-click-enabled="false"/>
</template>

<script>
import { mapState } from 'vuex'
import organizationsTable from './table'

export default {
  components: {
    organizationsTable
  },
  computed: {
    ...mapState('tenants', {
      view: '_archivedView'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/organizations/archived.vue